export default __webpack_public_path__ + "static/feature_case_study-cb43025ebf343719185b06bc3e3846b9.mp4";